export const FOOTER_LOCALE = {
    expandText: 'More Information',
    collapseText: 'More Information'
};
